import { Outlet } from "react-router";
import biApi from "../../../../../api/biApi";
import {
  getEditUiReportUrl,
  getUiReportsUrl,
  getViewUiReportUrl,
} from "../../report-lists/reports/utilities/editReportUrl.ts";
import type { BiApiClient } from "../contexts/ApiClientProviderContext";
import { BiApiClientProvider } from "../contexts/BiApiClientProvider.tsx";

// Templates have no saved company report; preview their supplied configuration.
const buildTemplateTabularReport: BiApiClient["buildTabularReport"] = (body, done, error) =>
  biApi.uiReports.buildTabularReport({ ...body, reportId: "" }, done, error);

export default function TemplatesContainer() {
  return (
    <BiApiClientProvider<BiApiClient>
      api={{
        updateReport: biApi.uiReports.updateReport,
        addReport: biApi.uiReports.addReport,
        createDraftReport: biApi.uiReports.createDraftReport,
        getReport: biApi.uiReports.getReport,
        runTabularReport: biApi.uiReports.runTabularReport,
        buildTabularReport: buildTemplateTabularReport,
        buildTileReport: biApi.uiReports.buildTileReport,
        buildChartReport: biApi.uiReports.buildChartReport,
        buildPivotReport: biApi.uiReports.buildPivotReport,
        renameReport: biApi.uiReports.renameReport,
        changeReportGroup: biApi.uiReports.changeReportGroup,
        deleteReports: biApi.uiReports.deleteReports,
        getReportAuthorizationInfo: biApi.uiReports.getReportAuthorizationInfo,
        getReports: biApi.uiReports.getReports,
        getReportConfigurationForRunning: biApi.uiReports.getReportConfigurationForRunning,
        validateName: biApi.uiReports.validateReportName,
        getReportSharing: biApi.uiReports.getReportSharing,
        updateReportSharing: biApi.uiReports.updateReportSharing,
        getEditReportUrl: getEditUiReportUrl,
        getViewReportUrl: getViewUiReportUrl,
        getReportsUrl: getUiReportsUrl,
        getReportHistory: biApi.uiReports.getReportHistory,
      }}
    >
      <Outlet />
    </BiApiClientProvider>
  );
}
